import React from 'react';

import { notification, Modal } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';
import _ from 'lodash';
import moment from 'moment';

import getAutorizacionesTrabajoMenor from '../../../graphql/querys/tramites/getAutorizacionesTrabajoMenor.graphql';
import deleteAutorizacionTrabajoMenor from '../../../graphql/mutations/tramites/deleteAutorizacionesTrabajoMenor.graphql';

import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

import getAutorizacionesTrabajoMenorPorRangoConFiltros from '../../../graphql/querys/tramites/getAutorizacionesTrabajoMenorPorRangoConFiltros.graphql';
import getCantidadAutorizacionesTrabajoMenorConFiltros from '../../../graphql/querys/tramites/getCantidadAutorizacionesTrabajoMenorConFiltros.graphql';

import { descargarCSV } from '../funciones/descargarCSV';
import convertBase64toBlob from '../../common/documentos/convertBase64toBlob';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionsAutorizacion from '../../../actions/autorizacionViaje';
import * as actionsMain from '../../../actions/main';
import * as actionsPersonas from '../../../actions/personas';

import TablaAutorizacionesMenores from './TablaAutorizacionesMenores';
import getActuacionMinio from '../../../graphql/querys/contravenciones/getActuacionMinio.graphql'
import getMinioUrlAutorizacion from '../../../graphql/querys/tramites/getMinioUrlAutorizacionTrabajo.graphql'
import subirAutorizacionFirmadaTrabajoMenorPDF from '../../../graphql/mutations/tramites/subirAutorizacionFirmadaTrabajoMenorPDF.graphql'

import ReImprimirNota from '../ReImprimirNota';
import { errorService } from '../../../graphql/utils/utils';

const confirm = Modal.confirm;

@compose(
  graphql(getUsuario),
  graphql(deleteAutorizacionTrabajoMenor, {
    name: 'deleteAutorizacion',
    options: {
      refetchQueries: [{ query: getAutorizacionesTrabajoMenor }],
    },
  }),
  graphql(subirAutorizacionFirmadaTrabajoMenorPDF, {
    name: 'subirAutorizacionFirmadaTrabajoMenorPDF',
  })
  ,
  graphql(getMinioUrlAutorizacion, {
    name: 'getMinioUrlAutorizacion',
  })
)
class VerAutorizacionesTrabajoMenor extends React.Component {
  constructor(props) {
    super(props);

    let fechaIni = moment()
      .subtract(7, 'd')
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      .toDate();

    let fechaFin = moment()
      .endOf('day')
      .toDate();

    this.state = {
      loading: false,
      filtro: '',
      currentPage: 1,
      listaTotal: [],
      lista: [],
      listaOriginal: [],
      primeraCarga: true,
      imprimir: false,
      datosImpresion: {},
      fechaInicio: fechaIni,
      fechaFin: fechaFin,
      filtroNombre: null,
      filtroApellido: null,
      filtroTipo: null,
      filtroDocumento: null,
      pagina: 1,
      cantidadPorPagina: 10,
      cantidadTotal: 0,
      loadingTabla: false,
    };

    this.onDelete = this.onDelete.bind(this);
  }

  componentDidMount() {
    this.getAutorizacionesTrabajoMenorPorRangoConFiltros();
  }

  getAutorizacionesTrabajoMenorPorRangoConFiltros = () => {
    this.setState({ loadingTabla: true });
    this.props.client
      .query({
        query: getCantidadAutorizacionesTrabajoMenorConFiltros,
        variables: {
          fechaInicial: this.state.fechaInicio,
          fechaFinal: this.state.fechaFin,
          filtroNombre: this.state.filtroNombre,
          filtroApellido: this.state.filtroApellido,
          filtroDocumento: this.state.filtroDocumento,
        },
      })
      .then(resp => {

        if (
          resp.data.getCantidadAutorizacionesTrabajoMenorConFiltros ||
          resp.data.getCantidadAutorizacionesTrabajoMenorConFiltros == 0
        ) {
        this.setState({
            cantidadTotal: resp.data.getCantidadAutorizacionesTrabajoMenorConFiltros,
          });

          // console.log('VOY A LLAMAR CON: ', this.state);

          this.props.client
            .query({
              query: getAutorizacionesTrabajoMenorPorRangoConFiltros,
              variables: {
                fechaInicial: this.state.fechaInicio,
                fechaFinal: this.state.fechaFin,
                filtroNombre: this.state.filtroNombre,
                filtroApellido: this.state.filtroApellido,
                filtroDocumento: this.state.filtroDocumento,
                pagina: this.state.pagina,
                cantidadPorPagina: this.state.cantidadPorPagina,
              },
              fetchPolicy: 'network-only',
            })
            .then(res => {
              this.setState(
                {
                  ...this.state,
                  listaTotal:
                    res.data.getAutorizacionesTrabajoMenorPorRangoConFiltros,
                  listaOriginal:
                    res.data.getAutorizacionesTrabajoMenorPorRangoConFiltros,
                  primeraCarga: false,
                  loadingTabla: false,
                },
                function() {
                  this.ordenarLista(
                    this.state.pagina,
                    this.state.cantidadPorPagina
                  );
                }
              );
            })
            .catch(err => {
              console.log('ERROR EN EL AUTORIZACIONES DE VIAJES POR RANGO: ');
              console.log(err);
              errorService(err, {
                fechaInicial: this.state.fechaInicio,
                fechaFinal: this.state.fechaFin,
                filtroNombre: this.state.filtroNombre,
                filtroApellido: this.state.filtroApellido,
                filtroDocumento: this.state.filtroDocumento,
                pagina: this.state.pagina,
                cantidadPorPagina: this.state.cantidadPorPagina,
              });
              Modal.error({
                title: 'Error en la busqueda de autorizaciones de viaje',
                content:
                  'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
              });
            });
        }
      })
      .catch(err => {
        console.log(
          'ERROR A LA HORA DE OBTENER LA CANTIDAD TOTAL DE DOCUMENTOS'
        );
        console.log('EL ERROR ES: ', err);
        errorService(err, {
          fechaInicial: this.state.fechaInicio,
          fechaFinal: this.state.fechaFin,
          filtroNombre: this.state.filtroNombre,
          filtroApellido: this.state.filtroApellido,
          filtroDocumento: this.state.filtroDocumento,
        });
      })

  };

  filtrarPorNombre = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState(
      {
        ...this.state,
        filtroNombre: filtro,
        pagina: 1,
      },
      () => {
        this.getAutorizacionesTrabajoMenorPorRangoConFiltros();
      }
    );
  };

  filtrarPorApellido = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState(
      {
        ...this.state,
        filtroApellido: filtro,
        pagina: 1,
      },
      () => {
        this.getAutorizacionesTrabajoMenorPorRangoConFiltros();
      }
    );
  };

  filtrarPorDocumento = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.
    this.setState(
      {
        ...this.state,
        filtroDocumento: filtro,
        pagina: 1,
      },
      () => {
        this.getAutorizacionesTrabajoMenorPorRangoConFiltros();
      }
    );
  };

  onDelete(id) {
    //TODO: Hacer el onDelete.
    // console.log("Se desea eliminar la autorizacion con id ", id);

    let { usuario } = this.props;

    if (usuario.rol == 'SUPERVISOR' || usuario.rol == 'FUNCIONARIO') {
      let yo = this;
      confirm({
        title:
          'Realmente quiere eliminar esta autorizacion y su respectiva venta?',
        content: 'Esta accion no podrá deshacerse',
        onOk() {
          yo.props
            .deleteAutorizacion({
              variables: { _id: id },
            })
            .then(res => {
              let id = res.data.deleteAutorizacionTrabajoMenor;

              if (id) {
                yo.eliminarElementoYActualizarLista(id);

                notification.warning({
                  message:
                    'Autorizacion y su respectiva venta fueron eliminadas correctamente',
                  description: 'Se ha eliminado la autorizacion exitosamente',
                });
              }
            })
            .catch(err => {
              console.log(
                'Existio un error a la hora de eliminar la autorizacion de viaje de menores'
              );
              console.log(err);
              errorService(err, {
                _id: id,
              });
              Modal.error({
                title:
                  'Error en la eliminacion de la autorizacion y de su respectiva venta',
                content:
                  'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
              });
            });
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    } else {
      Modal.error({
        title:
          'Usted no tiene los permisos necesarios para realizar esta operación',
        content:
          'Para poder realizar esta función, debe tener mas permisos en su cuenta de los que tiene ahora mismo. Por favor, en caso de ser necesario, comuníquese con mesa de ayuda del departamento de informática.',
      });
    }
  }
  
  onSubirDocumentoFirmado = (id) => {
    console.log("Se desea subir el documento firmado con id ", id);
  }

  onVisualizarDocumento = async (idAutorizacion) => {
    const response = await this.props.client.query({
      query: getMinioUrlAutorizacion,
      variables: {
        idAutorizacion: idAutorizacion
      },
      fetchPolicy: 'network-only'
    });
    const documentUrl = response.data.getMinioUrlAutorizacionTrabajo;
    window.open(documentUrl, '_blank');
    return response.data.getMinioUrlAutorizacionTrabajo;
  }

  eliminarElementoYActualizarLista = idElemento => {
    //Esta funcion esta encargada de eliminar el elemento de la lista, actualizar el estado y re-generar la lista.
    let lTotal = [...this.state.listaTotal];
    let total = this.state.cantidadTotal;

    // eslint-disable-next-line no-unused-vars
    let removidos = _.remove(lTotal, elem => {
      return elem._id == idElemento;
    });
    this.setState(
      {
        ...this.state,
        listaTotal: lTotal,
        cantidadTotal: total - 1,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  // eslint-disable-next-line no-unused-vars
  onChange = (date, dateString) => {
    this.setState(
      {
        ...this.state,
        fechaInicio: date[0]
          .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toDate(),
        fechaFin: date[1]
          .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
          .toDate(),
        pagina: 1,
      },
      () => {
        this.getAutorizacionesTrabajoMenorPorRangoConFiltros();
      }
    );
  };

  // eslint-disable-next-line no-unused-vars
  ordenarLista = (numPagina, tamPagina) => {
    let listaOrdenada = _.orderBy(
      this.state.listaTotal,
      [
        autorizacion => {
          // return autorizacion.autorizado.apellido.toUpperCase();
          return autorizacion.fecha_creacion;
        },
      ],
      ['desc']
    );

    this.setState({
      ...this.state,
      currentPage: numPagina,
      lista: listaOrdenada,
    });
  };

  onImprimir = registro => {
    if (registro.modelo_nota) {
      let vinculos = [];
      _.forEach(registro.autorizantes, autorizante => {
        vinculos.push(autorizante.vinculo);
      });

      let stringVinculos = '';
      if (vinculos) {
        if (vinculos.length == 1) {
          stringVinculos = vinculos[0];
        }
        if (vinculos.length == 2) {
          stringVinculos = vinculos[0] + ' Y ' + vinculos[1];
        }
        if (vinculos.length == 3) {
          stringVinculos =
            vinculos[0] + ', ' + vinculos[1] + ' Y ' + vinculos[2];
        }
      }

      let nuevosAutorizantes = [];
      _.forEach(registro.autorizantes, autorizante => {
        nuevosAutorizantes.push({
          ...autorizante.persona,
          vinculo: autorizante.vinculo,
        });
      });

      let textoOperacion = `Este tramite fue exento del pago de tasa de justicia - Ley N° 1971 Art. 3 -`;
      if (registro && registro.venta) {
        let venta = registro.venta;
        textoOperacion = `Por este trámite se abono la suma de $${venta.importe} mediante el uso de ${venta.tipoPago}, en concepto de pago de tasa de justicia - Ley N° 1971 Art. 3 -`;
      }

      let datos = {
        autorizado: {
          ...registro.autorizado,
          fecha_nacimiento: registro.autorizado.fecha_nacimiento
            ? moment(registro.autorizado.fecha_nacimiento).toDate()
            : '',
          edad: registro.autorizado.fecha_nacimiento
            ? Math.floor(
                moment(new Date()).diff(
                  moment(registro.autorizado.fecha_nacimiento),
                  'years',
                  true
                )
              )
            : '',
        },
        autorizantes: [...nuevosAutorizantes],
        autorizantes_sin_domicilio: [...nuevosAutorizantes],
        autorizantes_con_domicilio: [...nuevosAutorizantes],
        autorizantes_con_formatoHtml: [...nuevosAutorizantes],
        autorizantes_trabajo_menor: [...nuevosAutorizantes],
        certifica_trabajo_menor: [...nuevosAutorizantes],
        autorizantes_firmas: [...nuevosAutorizantes],
        responsables: [...registro.responsables],
        responsables_simple: [...registro.responsables],
        responsables_sin_domicilio: [...registro.responsables],
        empleador:registro.empleador,
        vinculos: stringVinculos,
        numero_acta_nacimiento: registro.numero_acta_nacimiento,
        cantidad_dias: registro.cantidad_dias,
        fecha_creacion: new Date(registro.fecha_creacion),
        desde: moment(registro.desde).format('DD/MM/YYYY'),
        hasta: moment(registro.hasta).format('DD/MM/YYYY'),
        // tipo_autorizacion: this.state.tipo_autorizacion,
        numero: registro.numero,
        destinos: registro.destinos,
        organismo: registro.organismo,
        modelo_nota: registro.modelo_nota,
        venta: registro.venta,
        codigoUnicoVerificacion: registro.codigoUnicoVerificacion,
        textoOperacion: textoOperacion,
        domicilioActividad: registro.domicilioActividad
      };


      this.setState({
        ...this.state,
        loading: false,
        datosImpresion: datos,
        imprimir: true,
      });
    } else {
      // console.log("NO EXISTE MODELO DE NOTA");

      Modal.error({
        title: 'Error con la nota modelo',
        content:
          'La nota que esta autorizacion utilizó fue eliminada o modificada, por lo que no se puede volver a imprimir este tramite. Por favor, comuniquesé con mesa de ayuda en caso de ser necesario. ',
      });
    }
  };

  onDescargar = () => {
    let data = _.map(this.state.listaTotal, autorizacion => {
      return {
        tipo_doc: autorizacion.autorizado.tipo_doc,
        num_doc: autorizacion.autorizado.num_doc,
        nombre: autorizacion.autorizado.nombre,
        apellido: autorizacion.autorizado.apellido,
        fecha: moment(autorizacion.fecha_creacion).format('DD/MM/YYYY'),
        usuario: autorizacion.creador
          ? autorizacion.creador.apellido.toUpperCase()
          : '-',
      };
    });
    descargarCSV(
      ['Tipo Doc', 'Num Doc', 'Nombre', 'Apellido', 'Fecha', 'Usuario'],
      data,
      `ReporteDeAutorizacionesViajes-${moment().format('DD/MM/YYYY-HH:mm')}.csv`
    );
  };

  // eslint-disable-next-line no-unused-vars
  onChange = (date, dateString) => {
    this.setState(
      {
        ...this.state,
        fechaInicio: date[0]
          .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toDate(),
        fechaFin: date[1]
          .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
          .toDate(),
      },
      () => {
        this.getAutorizacionesTrabajoMenorPorRangoConFiltros();
      }
    );
  };

  generarRecibo = base64 => {
    const base64PdfBlob = convertBase64toBlob(base64, 'application/pdf');
    const filePdf = URL.createObjectURL(base64PdfBlob);
    window.open(filePdf);
  };

  cambiarPagina = pagina => {
    this.setState(
      {
        pagina: pagina,
      },
      () => {
        this.getAutorizacionesTrabajoMenorPorRangoConFiltros();
      }
    );
  };

  cambiarTamañoPagina = tamaño => {
    this.setState({
      cantidadPorPagina: tamaño,
    });
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        {!this.state.imprimir && (
          <TablaAutorizacionesMenores
            titulo={"Autorizaciones Trabajo Adolescente"}
            autorizaciones={this.state.lista}
            history={this.props.history}
            onDelete={this.onDelete}
            onSubirDocumentoFirmado={this.onSubirDocumentoFirmado}
            onVisualizarDocumento={this.onVisualizarDocumento}
            imprimir={this.onImprimir}
            filtrarPorNombre={this.filtrarPorNombre}
            filtrarPorApellido={this.filtrarPorApellido}
            filtrarPorDocumento={this.filtrarPorDocumento}
            filtrarPorTipo={this.filtrarPorTipo}
            textoFiltroNombre={this.state.filtroNombre}
            textoFiltroApellido={this.state.filtroApellido}
            textoFiltroDocumento={this.state.filtroDocumento}
            textoFiltroTipo={this.state.filtroTipo}
            onChange={this.onChange}
            onDescargar={this.onDescargar}
            fechaInicio={this.state.fechaInicio}
            fechaFin={this.state.fechaFin}
            pagina={this.state.pagina}
            cambiarPagina={this.cambiarPagina}
            cambiarTamañoPagina={this.cambiarTamañoPagina}
            total={this.state.cantidadTotal}
            cantidadPorPagina={this.state.cantidadPorPagina}
            loadingTabla={this.state.loadingTabla}
            usuario={this.props.usuario}
            generarRecibo={this.generarRecibo}
            subirAutorizacionFirmadaPDF={this.props.subirAutorizacionFirmadaTrabajoMenorPDF}
            emailDefault={["copreti@neuquen.gov.ar"]}
            tipoAutorizacion="trabajo"
          />
        )}

        {this.state.imprimir && (
          <ReImprimirNota
            datos={this.state.datosImpresion}
            idModeloNota={this.state.datosImpresion.modelo_nota._id}
            onCancel={() => this.setState({ ...this.state, imprimir: false })}
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actionsAutorizacion: bindActionCreators(actionsAutorizacion, dispatch),
  actionsMain: bindActionCreators(actionsMain, dispatch),
  actionsPersonas: bindActionCreators(actionsPersonas, dispatch),
});

function mapStateToProps(state) {
  // console.log("mapStateToPorps: ", state);
  return state;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withApollo(VerAutorizacionesTrabajoMenor, getActuacionMinio));
